// Fluent UI's `merge-styles` (used by the RoosterJS editor toolbar, MergeStudiesModal and the
// comments input) names its generated classes "css-0", "css-1"... - the same names MUI's emotion
// uses. Its first class, created as soon as `@fluentui/utilities` is evaluated, is a scroll-lock
// helper (`overflow: hidden !important`), so once any page loading Fluent UI was visited (e.g. a
// study), every MUI `Box` with an empty `sx` ("css-0") stopped scrolling on the pages navigated
// to afterwards, until a full reload. Namespacing Fluent's classes ("fluent-css-0") prevents the
// collision. merge-styles reads this config once, when its stylesheet is first created, so this
// module must be imported before anything else.
type FabricWindow = Window & { FabricConfig?: { mergeStyles?: Record<string, unknown> } };

const fabricWindow = window as FabricWindow;
fabricWindow.FabricConfig = {
  ...fabricWindow.FabricConfig,
  mergeStyles: { ...fabricWindow.FabricConfig?.mergeStyles, namespace: 'fluent' },
};

export {};
